import { c as _c } from "react/compiler-runtime";
import { logoLockupGap, logoLockupWidth, logoMarkHeight, logoMarkViewBox, logoMarkWidth, logoPaths, logoWordmark, logoWordmarkWidth } from "@/core/logo-paths";
import type { SVGProps } from "react";
export type LogoProps = SVGProps<SVGSVGElement>;

/** The DigitSpace mark. Takes its colour from `currentColor`. */
export function Logo(props) {
  const $ = _c(4);
  const t0 = props["aria-label"] ? undefined : true;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = logoPaths.map(_temp);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== props || $[2] !== t0) {
    t2 = <svg xmlns="http://www.w3.org/2000/svg" viewBox={logoMarkViewBox} fill="currentColor" aria-hidden={t0} {...props}>{t1}</svg>;
    $[1] = props;
    $[2] = t0;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}

/**
 * Mark and wordmark in one SVG, for the DOM only: the wordmark is live text,
 * which OG image rendering can't draw.
 */
function _temp(d) {
  return <path key={d} d={d} fillRule="evenodd" />;
}
export function LogoLockup(props) {
  const $ = _c(4);
  const name = `${logoWordmark.lead}${logoWordmark.tail}`;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = logoPaths.map(_temp2);
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <text x={logoMarkWidth + logoLockupGap} y={logoWordmark.baseline} textLength={logoWordmarkWidth} lengthAdjust="spacingAndGlyphs" style={{
      fontFamily: logoWordmark.fontFamily,
      fontSize: logoWordmark.fontSize,
      letterSpacing: logoWordmark.letterSpacing
    }}><tspan style={{
        fontWeight: logoWordmark.leadWeight
      }}>{logoWordmark.lead}</tspan><tspan style={{
        fontWeight: logoWordmark.tailWeight
      }}>{logoWordmark.tail}</tspan></text>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== props) {
    t2 = <svg xmlns="http://www.w3.org/2000/svg" viewBox={`0 0 ${logoLockupWidth} ${logoMarkHeight}`} fill="currentColor" role="img" aria-label={name} {...props}>{t0}{t1}</svg>;
    $[2] = props;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}
function _temp2(d) {
  return <path key={d} d={d} fillRule="evenodd" />;
}